import styled from 'styled-components';
var Wrapper = styled.div.withConfig({
  displayName: "RectangleSkeletonstyles__Wrapper",
  componentId: "sc-1sovjrf-0"
})(["padding:0 0 15px;border:none;"]);
export { Wrapper };